import Vue from 'vue';

// import LqInput from './Input';
// import LqSelect from './Select';
// import LqImage from './File/Image';
// import LqFile from './File/File';
import LqSubmit from './Submit';
import confirm from './Confirm'

// import LqTimePicker from './TimePicker';
// import LqDatePicker from './DatePicker';
// import RadioGroup from './RadioGroup';
// import LqCheckboxGroup from './CheckboxGroup';
// import LqCheckbox from './Checkbox';
// import LqGooglePlace from './Place';
import LqElTabs from './Tab';
// import LqColor from './Color';
// import userInput from './Username';
// import mobileNo from './MobileNo';
// import './lq.element.css';

// Vue.component('lq-el-select', LqSelect)
// Vue.component('user-input', userInput);
// Vue.component('mobile-no', mobileNo);
Vue.component('lq-el-tabs', LqElTabs);
// Vue.component('lq-el-color-picker', LqColor);
// Vue.component('lq-el-input', LqInput)
Vue.component('lq-el-submit', LqSubmit)
// Vue.component('lq-el-image', LqImage)
// Vue.component('lq-el-file', LqFile)
// Vue.component('lq-el-time-picker', LqTimePicker)
// Vue.component('lq-el-date-picker', LqDatePicker)
// Vue.component('lq-el-radio-group', RadioGroup)
// Vue.component('lq-el-checkbox-group', LqCheckboxGroup)
// Vue.component('lq-el-checkbox', LqCheckbox)
// Vue.component('lq-el-google-place', LqGooglePlace)


Vue.use(confirm, {
    buttonTrueText: 'Yes',
    buttonFalseText: 'Discard',
    color: 'warning',
    icon: 'warning',
    title: 'Warning',
    width: 350,
    property: '$lqdialog'
})